import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import {getStorage} from 'firebase/storage'; // Storage is now handled by Cloudinary

const firebaseConfig = {
  apiKey: "AIzaSyCA6VFHEXD_apl6Bw3spZQHjKlMfpyyx9w",
  authDomain: "cloud-point-2026.firebaseapp.com",
  projectId: "cloud-point-2026",
  storageBucket: "cloud-point-2026.firebasestorage.app",
  messagingSenderId: "21770740343",
  appId: "1:21770740343:web:ccbbcea6b7c8054e979c72",
  measurementId: "G-CEPS62WL50"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); // Only export auth, not storage
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export default app;